export const searchResults = "w_a";
export const searchResultsFromArchive = "x_a";
export default {searchResults,searchResultsFromArchive};